import type * as Types from '../../graphql/types.d'

import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type FetchSignedUploadUrlQueryVariables = Types.Exact<{
	mediaType: Types.MediaType
}>

export type FetchSignedUploadUrlQuery = {
	__typename?: 'Query'
	fetchSignedUploadUrl: { __typename?: 'SignedUrl'; id: string; url: string }
}

export const FetchSignedUploadUrlDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'FetchSignedUploadUrl' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaType' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaType' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'fetchSignedUploadUrl' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'mediaType' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaType' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode
